// src/components/admin/AdminNavbar.jsx
import React from "react";

const AdminNavbar = ({ setActiveTab, handleLogout }) => {
  return (
    <nav className="bg-black bg-opacity-80 text-white px-6 py-4 flex justify-between items-center shadow-lg">
      <h1 className="text-2xl font-bold tracking-wide">Placify Admin Portal</h1>
      <div className="flex gap-6">
        <button onClick={() => setActiveTab("registerAccount")} className="hover:text-yellow-400">Register Account</button>
        <button onClick={() => setActiveTab("registerStudent")} className="hover:text-yellow-400">Register Student</button>
        <button onClick={() => setActiveTab("students")} className="hover:text-yellow-400">Students</button>
        <button onClick={handleLogout} className="text-red-400 font-semibold">Logout</button>
      </div>
    </nav>
  );
};

export default AdminNavbar;
